// extracted by mini-css-extract-plugin
export default {"list":"ErrorList_list__2m84S"};